import * as React from "react";
import { useResetPassword } from "./useResetPassword";
import { AsButton, AsInput } from "app/subframe";
import { Loading } from "app/components/loading/loading";

export interface ResetPasswordProps {}

export const ResetPassword: React.FC<ResetPasswordProps> = ({}) => {
  const { user, isLoading, isSubmitting, isTokenValid, onSubmit } =
    useResetPassword();

  if (isLoading) {
    return (
      <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
        <Loading label="Validating reset link" type="dark" />
      </div>
    );
  }

  if (!isTokenValid) {
    return (
      <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
        <h1 className="text-lg font-semibold">
          This reset link is invalid or has expired
        </h1>
        <p>Please ask your admin to send you a new password reset email</p>
      </div>
    );
  }

  return (
    <div className="w-screen h-screen flex flex-col gap-4 items-center justify-center">
      <form
        className="flex flex-col gap-4 w-[600px] border-zinc-100 p-8 rounded-sm"
        onSubmit={onSubmit}
      >
        <div className="flex flex-col gap-4 mb-8 items-center">
          <h1 className="font-semibold text-lg">Reset Password</h1>
          <div className="flex flex-col gap-1 items-center">
            <p className="text-sm text-zinc-500">
              Hi {user?.name}, set a new password for your account at{" "}
              <span className="text-body-bold font-body-bold text-neutral-900">
                {user?.account?.name}
              </span>
            </p>
          </div>
        </div>
        <AsInput
          label="Email"
          name="email"
          type="email"
          className="!bg-transparent border-none hover:border-none"
          placeholder="Enter email"
          value={user?.email}
          disabled
          textPosition="left"
        />
        <AsInput
          label="New Password"
          name="password"
          type="password"
          required
          placeholder="Enter new password"
          textPosition="left"
        />
        <AsInput
          label="Confirm Password"
          name="passwordConfirmation"
          type="password"
          required
          placeholder="Re-enter new password to confirm"
          textPosition="left"
        />
        <AsButton
          size="md"
          type="submit"
          text="Reset Password"
          disabled={isSubmitting}
        />
      </form>
    </div>
  );
};
